import React from 'react';
import './FormGroup.css';

/**
 * FormGroup Component
 * Wrapper for related form fields (e.g., name first/last)
 * 
 * @param {string} label - Group label
 * @param {string} error - Error message
 * @param {boolean} required - Required field indicator
 * @param {ReactNode} children - Group content (form fields)
 * @param {string} className - Additional CSS classes
 */
const FormGroup = ({
  label,
  error,
  required = false,
  children,
  className = ''
}) => {
  const groupId = `form-group-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className={`form-group ${error ? 'error' : ''} ${className}`.trim()}>
      {label && (
        <label className="form-group-label">
          {label}
          {required && <span className="form-group-required">*</span>}
        </label>
      )}
      <div className="form-group-fields">
        {children}
      </div>
      {error && (
        <span id={`${groupId}-error`} className="form-group-error" role="alert">
          {error}
        </span>
      )}
    </div>
  );
};

export default FormGroup;










